
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { Getter } from 'vuex-class';

@Component({
  name: 'EmailGravatar',
})
export default class EmailGravatar extends Vue {
  @Getter ticks: number;

  @Getter('baseUrl') baseUrl;

  @Prop({
    type: Number,
    default: 24,
  })
  size: number;

  @Prop({
    type: String,
    required: true,
  })
  email: string;

  @Prop({
    type: Boolean,
    required: false,
  })
  grayed: boolean;

  @Prop({
    type: Number,
    required: false,
  })
  id: number;

  get safeEmail(): string {
    if (this.email && this.email.length) return this.email;
    if (this.id) return this.$hashids.encode(this.id);
    return '-';
  }
}
